import React from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    EventsLoader,
    SelectionLoader,
    SilkLoader,
    FirstLineRacecardLoader,
    SecondLineRacecardLoader,
    PriceHistory,
    PriceHistoryWrapper,
    HorseInfoWrapper,
    RaceboxWrapper,
    WeightLoader,
    SelectionSPLoader,
} from 'src/domains/layouts/shared/loaders';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

export const RaceRow = observer('RaceRow', () => {
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;
    const { selectionVariant, sportsbookVariant } = configState.componentVariants;
    return (
        <RaceboxWrapper variant={sportsbookVariant}>
            <HorseInfoWrapper>
                <SilkLoader />

                <EventsLoader>
                    <FirstLineRacecardLoader />
                    <SecondLineRacecardLoader />
                </EventsLoader>
            </HorseInfoWrapper>
            <PriceHistoryWrapper>
                <WeightLoader variant={selectionVariant} />
                <PriceHistory />
                <SelectionLoader variant={selectionVariant} />
                <SelectionSPLoader variant={selectionVariant} />
            </PriceHistoryWrapper>
        </RaceboxWrapper>
    );
});
